export default "__VITE_ASSET__16c23b58__"